export default __webpack_public_path__ + "static/media/MotorTrend.61b3a6fa.svg";